import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const formatTime = (seconds: number) => {
  if (seconds <= 0 || isNaN(seconds)) return "00:00";

  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  const HH = hrs > 0 ? `${hrs.toString().padStart(2, "0")}:` : "";
  const MM = mins.toString().padStart(2, "0");
  const SS = secs.toString().padStart(2, "0");

  return `${HH}${MM}:${SS}`;
};

// Calculate percentage
export const calculatePercentage = (value: number, total: number) => {
  return total > 0 ? Math.round((value / total) * 100) : 0;
};